import { PPAC_API_URL } from '../config/apiRoutes';
import { createAxiosHttpClient } from '../http-client/axios-client';
import { ApiAgencyGateway } from './agency.gateway';
import { MockedAgencyGateway } from './mocked-agencies.gateway';
export class AgencyModule {
    agencyGateway;
    constructor() {
        this.agencyGateway = this.initializeAgencyGateway();
    }
    initializeAgencyGateway() {
        if (process.env.FAKE_PP_IMPLEMENTATION === 'true') {
            return new MockedAgencyGateway();
        }
        const httpClient = createAxiosHttpClient(PPAC_API_URL);
        return new ApiAgencyGateway(httpClient);
    }
    getAgencyGateway() {
        return this.agencyGateway;
    }
}
export const initializeGatewayModule = () => {
    const agencyModule = new AgencyModule();
    return agencyModule.getAgencyGateway();
};
